<mat-card class="card1">
<!--     
    <div class="container">
        <iframe class="abc" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d193163.96131678837!2d78.9460762622504!3d30.98239971522398!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39080f95f81930c5%3A0x62ab20db2d456d4e!2sSri%20Kailas!5e0!3m2!1sen!2sin!4v1590310557212!5m2!1sen!2sin" width="800" height="600" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe> 
        <span><img class="image" src="{{userDetails.image.url}}"></span>     
    </div>
    
        <div class="row">
            <div class="col-md-4">

            </div>
            <div class="col-md-4">
        
            </div>
            <div class="col-md-4">
        
            </div>
        </div> -->
<div class="main">
    <div class="heading">
      <h4 class="card-title">Profile</h4>
    </div>
    <form (ngSubmit)="f.form.valid && UpdateMember()" #f="ngForm">
        <label>
            <img [src]="userDetails.image.url" #ima class="img1">
            <input type="file"  accept="image/*" (onclick)="ima" (change)="showPreview($event)" hidden/>
          </label>
          <div *ngIf="currentUpload">
            Progress: {{ currentUpload?.progress }}%
            Complete
            <div class="progress">
              <div
                class="progress-bar progress-bar-animated"
                [ngStyle]="{ width: currentUpload?.progress + '%' }"
              ></div>
              </div></div>
          <div *ngIf="delete1"><mat-icon class="delete" (click)="deletePreviousFile()">delete</mat-icon></div>
          
          <br>
          <div class="row">

        <div class="col-md-4">

        
  <mat-form-field class="example-full-width">
    <mat-label>Full Name</mat-label>
    <input matInput placeholder="Full Name" name="name" [(ngModel)]="userDetails.name"  value="" #firstName="ngModel" [ngClass]="{ 'is-invalid': f.submitted && firstName.invalid }" required />
    <span matPrefix><mat-icon>face</mat-icon></span>
    <!-- <div *ngIf="f.submitted && firstName.invalid" class="invalid-feedback abcd">
      <div *ngIf="firstName.errors.required">Name is required</div>
  </div>   -->
  </mat-form-field>
   
  <div
  [hidden]="firstName.valid || firstName.pristine"
  class="erro1"
>Name is Required
</div>
        </div>  
        <div class="col-md-4">
          <mat-form-field class="example-full-width">
            <mat-label>Email</mat-label>
            <input matInput type="email" placeholder="Email" name="email" [(ngModel)]="userDetails.email" #email="ngModel" disabled [ngClass]="{ 'is-invalid': f.submitted && email.invalid }" required email />
           
            <span matPrefix><mat-icon>email</mat-icon></span>
            <!-- <div *ngIf="f.submitted && email.invalid" class="invalid-feedback abcd">
                <div *ngIf="email.errors.required">Email is required</div>
                <div *ngIf="email.errors.email">Email must be a valid email address</div>
            </div> -->

          </mat-form-field>
         <div
            [hidden]="email.valid || email.pristine"
            class="erro1"
          >
            <div *ngIf="email.errors?.required">Email is required</div>
            <div *ngIf="email.errors?.email">
              Email must be a valid email address
            </div>
          </div></div>
          


<div class="col-md-4">
  <mat-form-field class="example-full-width">
    <mat-label>Phone</mat-label>
    <input matInput placeholder="Phone No" type='tel' name="phone" [(ngModel)]="userDetails.phone" #phone="ngModel" required minlength="10" maxlength='10'>
    <span matPrefix>   <mat-icon>phone</mat-icon></span>
    <!-- <div *ngIf="f.submitted && phone.invalid" class="invalid-feedback abcd">
      <div *ngIf="phone.errors.required">Phone is required</div>
  </div> -->
  </mat-form-field> 
  
  <div
  [hidden]="phone.valid || phone.pristine"
  class="erro1"
>
Phone is required.
</div>
</div>
<div class="col-md-4">

  <mat-form-field class="example-full-width">
    <mat-label>Address</mat-label>
    <input matInput placeholder="Address" name="address" [(ngModel)]="userDetails.address" value="">
    <span matPrefix><mat-icon>location_on</mat-icon></span> 
  </mat-form-field>
</div>


          </div>
       
       
          <!-- <mat-form-field class="example-full-width">
         
                <mat-label>Payment Option</mat-label>
                <mat-select #mySel matNativeControl [(ngModel)]="userDetails.paymentOption" name="unit" multiple="true"  (selectionChange)="paymentChange($event.value)">
                    <mat-option [value]="0" (click)="toggleAllSelection()">All</mat-option>
                  <mat-option [value]="credit" >Credit</mat-option>
                  <mat-option [value]="debit">Debit</mat-option>
                  <mat-option [value]="upi">UPI</mat-option>

                </mat-select>
          </mat-form-field> -->
      
      
          

          <br>
          <button mat-button mat-raised-button [disabled]="f.invalid" class="btn" class="add">UPDATE PROFILE</button>
    </form>
</div>
</mat-card>
